import React from "react";
import { Helmet } from "react-helmet";
const config = require("../config");

const SEO = ({ generateFrom }) => {
    let metaTags = {
        title:
            generateFrom.title !== undefined
                ? generateFrom.title
                : config.siteName,
        description: generateFrom.overview ? generateFrom.overview : "",
        keywords: generateFrom.title
            ? generateFrom.title
                  .toLowerCase()
                  .split(" ")
                  .join(",") +
              ", " +
              generateFrom.release_date
            : "Track Movies &copy; 2018",
        robots: "index, follow"
    };

    let twitterCardData = {
        "twitter:card": generateFrom.backdrop_path
            ? config.tmdbAPIBackdropLink.replace(
                  "BACKDROP_LINK",
                  generateFrom.backdrop_path
              )
            : config.brokenImages.backdrop,
        "twitter:site": "@trackmovies",
        "twitter:title":
            generateFrom.title && generateFrom.release_date
                ? `${generateFrom.title} (${
                      generateFrom.release_date.split("-")[0]
                  })`
                : config.siteName,
        "twitter:description": generateFrom.overview
            ? `${generateFrom.overview.slice(0, 180)}...`
            : "",
        "twitter:creator": "@trackmovies",
        "twitter:image:src": generateFrom.poster_path
            ? config.tmdbAPIPosterLink.replace(
                  "POSTER_LINK",
                  generateFrom.poster_path
              )
            : config.brokenImages.poster
    };

    let opengraphData = {
        "og:title": generateFrom.title ? generateFrom.title : config.siteName,
        "og:type": "video.movie",
        "og:url": generateFrom.imdb_id
            ? `https://www.imdb.com/title/${generateFrom.imdb_id}`
            : "Unknown IMDB ID.",
        "og:image": generateFrom.poster_path
            ? config.tmdbAPIPosterLink.replace(
                  "POSTER_LINK",
                  generateFrom.poster_path
              )
            : config.brokenImages.poster,
        "og:description": generateFrom.overview ? generateFrom.overview : "",
        "og:site_name": `Track ${
            generateFrom.title ? generateFrom.title : "Movies"
        }`,
        "video:release_date": generateFrom.release_date
            ? generateFrom.release_date
            : "Unknown",
        "video:duration": generateFrom.runtime
            ? generateFrom.runtime
            : "Unknown",
        "video:tag": generateFrom.tagline ? generateFrom.tagline : ""
    };

    var finalMetaData = [];

    // Create normal meta tags.
    Object.keys(metaTags).forEach(function(key) {
        var tempElement = document.createElement("meta");
        tempElement.setAttribute("name", key);
        tempElement.setAttribute("content", metaTags[key]);
        finalMetaData.push(tempElement);
    });

    // Create Twitter card data.
    Object.keys(twitterCardData).forEach(function(key) {
        var tempElement = document.createElement("meta");
        tempElement.setAttribute("name", key);
        tempElement.setAttribute("content", twitterCardData[key]);
        finalMetaData.push(tempElement);
    });

    // Create Open Graph meta data.
    Object.keys(opengraphData).forEach(function(key) {
        var tempElement = document.createElement("meta");
        tempElement.setAttribute("property", key);
        tempElement.setAttribute("content", opengraphData[key]);
        finalMetaData.push(tempElement);
    });

    // Append those meta tags to our document's head.
    // const toReturn = <Helmet>Seo Tags</Helmet>;

    return (
        <Helmet>
            {finalMetaData
                ? finalMetaData.forEach(meta => {
                      //   console.log(meta);
                      return meta;
                  })
                : ""}
        </Helmet>
    );
};

export default SEO;



// WEBPACK FOOTER //
// ./src/components/SEO.js